import { render, staticRenderFns } from "./cust-referrer.vue?vue&type=template&id=317002d8&scoped=true"
import script from "./cust-referrer.vue?vue&type=script&lang=js"
export * from "./cust-referrer.vue?vue&type=script&lang=js"
import style0 from "./cust-referrer.vue?vue&type=style&index=0&id=317002d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317002d8",
  null
  
)

export default component.exports